module.exports = __webpack_public_path__ + "img/党建100图标-迅捷压缩.1f392a17.png";